export default {
  methods: {
    formatarDinheiro(quantia) {
      if (!quantia)
        quantia = 0.0;

      return quantia.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    },
    formatarDinheiroSemSimbolo(quantia) {
      if (!quantia)
        quantia = 0.0;

      return quantia.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    formatarPorcentagem(quantia) {
      if (!quantia)
        quantia = 0.0;

      return quantia.toLocaleString('pt-BR', {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      })
    },
    formatarDinheiroParenteses(quantia) {
      var menorZero = false;
      if (!quantia)
        quantia = 0.0;

      if (quantia < 0) {
        menorZero = true;
        quantia *= -1;
      }

      quantia = this.formatarDinheiro(quantia);

      if (menorZero)
        return "(" + quantia + ")";
      return quantia
    },
  }
}
